'use strict'
import { codeData } from '@/utils/codeData';

const executives = {
  path: 'person-enterprise',
  name: 'executives',
  meta: {
    title: '秀川结算中心-综合服务平台',
    name: '董监高人员监测',
    code: ''
  },
  component: () => import('@/pages/executives/ExecutivesList'),
};


export default executives;
